internalQueryRef